import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import authStore from '../../../stores/authStore';

interface ProtectedRouteProps {
  path: any;
  exact?: boolean;
  component: any;
}

const ProtectedRoute = (props: ProtectedRouteProps) => {
  const path = props.path;
  const component = props.component;

  return authStore.adminRole === 'superadmin' ? (
    <Route path={path} exact={props.exact ? props.exact : false} component={component} />
  ) : (
    <Redirect to={{ pathname: '/videos' }} />
  );
};

export default ProtectedRoute;
